webpackJsonp([35783957827783],{

/***/ 219:
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var emotionUtils = __webpack_require__(19);
	var PropTypes = _interopDefault(__webpack_require__(6));
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var channel = '__EMOTION_THEMING__';
	
	var _contextTypes;
	
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	function setTheme(theme) {
	  this.setState({
	    theme: theme
	  });
	}
	var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|accept|acceptCharset|accessKey|action|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan)|(on[A-Z].*)|((data|aria)-.*))$/;
	var testOmitPropsOnStringTag = emotionUtils.memoize(function (key) {
	  return reactPropsRegex.test(key);
	});
	var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
	  return key !== 'theme' && key !== 'innerRef';
	};
	var testAlwaysTrue = function testAlwaysTrue() {
	  return true;
	};
	var omitAssign = function omitAssign(testFn, target) {
	  var i = 2;
	  var length = arguments.length;
	
	  for (; i < length; i++) {
	    var source = arguments[i];
	
	    var _key = void 0;
	
	    for (_key in source) {
	      if (testFn(_key)) {
	        target[_key] = source[_key];
	      }
	    }
	  }
	
	  return target;
	};
	
	function _componentWillMount() {
	  if (this.context[channel] !== undefined) {
	    this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
	  }
	}
	
	function _componentWillUnmount() {
	  if (this.unsubscribe !== undefined) {
	    this.context[channel].unsubscribe(this.unsubscribe);
	  }
	}
	
	function _get(target, property) {
	  switch (property) {
	    // react-hot-loader tries to access this stuff
	    case '__proto__':
	    case 'name':
	    case 'prototype':
	    case 'displayName':
	      {
	        return target[property];
	      }
	
	    default:
	      {
	        throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
	      }
	  }
	}
	
	function createEmotionStyled(emotion, view) {
	  var _createStyled = function createStyled(tag, options) {
	    if (false) {
	      if (tag === undefined) {
	        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
	      }
	    }
	
	    var staticClassName;
	    var identifierName;
	    var stableClassName;
	
	    if (options !== undefined) {
	      staticClassName = options.e;
	      identifierName = options.label;
	      stableClassName = options.target;
	    }
	
	    var isReal = tag.__emotion_real === tag;
	    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;
	    var omitFn = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
	
	    function _value() {
	      if (false) {
	        return 'NO_COMPONENT_SELECTOR';
	      }
	
	      return "." + stableClassName;
	    }
	
	    return function () {
	      var args = arguments;
	      var styles = isReal && tag[emotionUtils.STYLES_KEY] !== undefined ? tag[emotionUtils.STYLES_KEY].slice(0) : [];
	
	      if (identifierName !== undefined) {
	        styles.push("label:" + identifierName + ";");
	      }
	
	      if (staticClassName === undefined) {
	        if (args[0] == null || args[0].raw === undefined) {
	          styles.push.apply(styles, args);
	        } else {
	          styles.push(args[0][0]);
	          var len = args.length;
	          var i = 1;
	
	          for (; i < len; i++) {
	            styles.push(args[i], args[0][i]);
	          }
	        }
	      }
	
	      function _render() {
	        var props = this.props,
	            state = this.state;
	        this.mergedProps = omitAssign(testAlwaysTrue, {}, props, {
	          theme: state !== null && state.theme || props.theme || {}
	        });
	        var className = '';
	        var classInterpolations = [];
	
	        if (props.className) {
	          if (staticClassName === undefined) {
	            className += emotion.getRegisteredStyles(classInterpolations, props.className);
	          } else {
	            className += props.className + " ";
	          }
	        }
	
	        if (staticClassName === undefined) {
	          className += emotion.css.apply(this, styles.concat(classInterpolations));
	        } else {
	          className += staticClassName;
	        }
	
	        if (stableClassName !== undefined) {
	          className += " " + stableClassName;
	        }
	
	        return view.createElement(baseTag, omitAssign(omitFn, {}, props, {
	          className: className,
	          ref: props.innerRef
	        }));
	      }
	
	      var Styled =
	      /*#__PURE__*/
	      function (_view$Component) {
	        _inheritsLoose(Styled, _view$Component);
	
	        function Styled() {
	          return _view$Component.apply(this, arguments) || this;
	        }
	
	        var _proto = Styled.prototype;
	        _proto.componentWillMount = _componentWillMount;
	        _proto.componentWillUnmount = _componentWillUnmount;
	        _proto.render = _render;
	        return Styled;
	      }(view.Component);
	
	      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
	      Styled.contextTypes = contextTypes;
	      Styled[emotionUtils.STYLES_KEY] = styles;
	      Styled.__emotion_base = baseTag;
	      Styled.__emotion_real = Styled;
	      Object.defineProperty(Styled, 'toString', {
	        enumerable: false,
	        value: _value
	      });
	
	      Styled.withComponent = function (nextTag, nextOptions) {
	        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
	        omitAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, args);
	      };
	
	      return Styled;
	    };
	  };
	
	  if (false) {
	    _createStyled = new Proxy(_createStyled, {
	      get: _get
	    });
	  }
	
	  return _createStyled;
	}
	
	module.exports = createEmotionStyled;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var emotionUtils = __webpack_require__(19);
	var stylisRuleSheet = _interopDefault(__webpack_require__(56));
	
	var hyphenateRegex = /[A-Z]|^ms/g;
	var processStyleName = emotionUtils.memoize(function (styleName) {
	  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	var processStyleValue = function processStyleValue(key, value) {
	  if (value == null || typeof value === 'boolean') {
	    return '';
	  }
	
	  if (emotionUtils.unitless[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
	  !isNaN(value) && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'function':
	        toAdd = classnames([arg()]);
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	var isBrowser = typeof document !== 'undefined';
	
	/*
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	- 'polyfills' on server side
	
	// usage
	
	import StyleSheet from 'glamor/lib/sheet'
	let styleSheet = new StyleSheet()
	
	styleSheet.inject()
	- 'injects' the stylesheet into the page (or into memory if on server)
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function makeStyleTag(opts) {
	  var tag = document.createElement('style');
	  tag.type = 'text/css';
	  tag.setAttribute('data-emotion', opts.key || '');
	
	  if (opts.nonce !== undefined) {
	    tag.setAttribute('nonce', opts.nonce);
	  }
	
	  tag.appendChild(document.createTextNode('')) // $FlowFixMe
	  ;
	  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
	  return tag;
	}
	
	function _StyleSheet(options) {
	  this.isSpeedy = ("production") === 'production'; // the big drawback here is that the css won't be editable in devtools
	
	  this.tags = [];
	  this.ctr = 0;
	  this.opts = options;
	}
	
	function _inject() {
	  if (this.injected) {
	    throw new Error('already injected!');
	  }
	
	  this.tags[0] = makeStyleTag(this.opts);
	  this.injected = true;
	}
	
	function _speedy(bool) {
	  if (this.ctr !== 0) {
	    // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
	    throw new Error("cannot change speedy now");
	  }
	
	  this.isSpeedy = !!bool;
	}
	
	function _insert(rule, sourceMap) {
	  // this is the ultrafast version, works across browsers
	  if (this.isSpeedy) {
	    var tag = this.tags[this.tags.length - 1];
	    var sheet = sheetForTag(tag);
	
	    try {
	      sheet.insertRule(rule, sheet.cssRules.length);
	    } catch (e) {
	      if (false) {
	        console.warn('illegal rule', rule); // eslint-disable-line no-console
	      }
	    }
	  } else {
	    var _tag = makeStyleTag(this.opts);
	
	    this.tags.push(_tag);
	
	    _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
	  }
	
	  this.ctr++;
	
	  if (this.ctr % 65000 === 0) {
	    this.tags.push(makeStyleTag(this.opts));
	  }
	}
	
	function _ref(tag) {
	  return tag.parentNode.removeChild(tag);
	}
	
	function _flush() {
	  // $FlowFixMe
	  this.tags.forEach(_ref);
	  this.tags = [];
	  this.ctr = 0; // todo - look for remnants in document.styleSheets
	
	  this.injected = false;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  var _proto = _StyleSheet.prototype;
	  _proto.inject = _inject;
	  _proto.speedy = _speedy;
	  _proto.insert = _insert;
	  _proto.flush = _flush;
	  return _StyleSheet;
	}();
	
	function createEmotion(context, options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	
	  if (false) {
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  } // $FlowFixMe
	
	
	  var caches = context.__SECRET_EMOTION__;
	  var current;
	
	  function insertRule(rule) {
	    current += rule;
	
	    if (isBrowser) {
	      sheet.insert(rule, currentSourceMap);
	    }
	  }
	
	  var insertionPlugin = stylisRuleSheet(insertRule);
	
	  if (caches === undefined) {
	    var stylisOptions = {
	      keyframe: false,
	      global: false,
	      prefix: options.prefix === undefined ? true : options.prefix,
	      semicolon: true
	    };
	
	    if (false) {
	      stylisOptions.compress = false;
	    }
	
	    context.__SECRET_EMOTION__ = caches = {
	      registered: {},
	      inserted: {},
	      sheet: new StyleSheet(options),
	      stylis: new emotionUtils.Stylis(stylisOptions),
	      nonce: options.nonce,
	      key: key
	    };
	    caches.stylis.use(options.stylisPlugins)(insertionPlugin); // 🚀
	
	    if (isBrowser) {
	      caches.sheet.inject();
	    }
	  }
	
	  var stylis = caches.stylis;
	  var sheet = caches.sheet;
	  var currentSourceMap = '';
	
	  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
	    if (interpolation == null) {
	      return '';
	    }
	
	    switch (typeof interpolation) {
	      case 'boolean':
	        return '';
	
	      case 'function':
	        if (interpolation[emotionUtils.STYLES_KEY] !== undefined) {
	          var selector = interpolation.toString();
	
	          if (selector === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	          }
	
	          return selector;
	        }
	
	        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
	        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);
	
	      case 'object':
	        return createStringFromObject.call(this, interpolation);
	
	      default:
	        var cached = caches.registered[interpolation];
	        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
	    }
	  }
	
	  var objectToStringCache = new WeakMap();
	
	  function createStringFromObject(obj) {
	    if (objectToStringCache.has(obj)) {
	      // $FlowFixMe
	      return objectToStringCache.get(obj);
	    }
	
	    var string = '';
	
	    function _ref(interpolation) {
	      string += handleInterpolation.call(this, interpolation, false);
	    }
	
	    function _ref2(key) {
	      if (typeof obj[key] !== 'object') {
	        if (caches.registered[obj[key]] !== undefined) {
	          string += key + "{" + caches.registered[obj[key]] + "}";
	        } else {
	          string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
	        }
	      } else {
	        if (key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
	      }
	    }
	
	    if (Array.isArray(obj)) {
	      obj.forEach(_ref, this);
	    } else {
	      Object.keys(obj).forEach(_ref2, this);
	    }
	
	    objectToStringCache.set(obj, string);
	    return string;
	  }
	
	  var name;
	  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	
	  var createStyles = function createStyles(strings) {
	    var stringMode = true;
	    var styles = '';
	    var identifierName = '';
	
	    if (strings == null || strings.raw === undefined) {
	      stringMode = false;
	      styles += handleInterpolation.call(this, strings, false);
	    } else {
	      styles += strings[0];
	    }
	
	    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    interpolations.forEach(function (interpolation, i) {
	      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
	      );
	
	      if (stringMode === true && strings[i + 1] !== undefined) {
	        styles += strings[i + 1];
	      }
	    }, this);
	    styles = styles.replace(labelPattern, function (match, p1) {
	      identifierName += "-" + p1;
	      return '';
	    });
	    name = emotionUtils.hashString(styles + identifierName) + identifierName;
	    return styles;
	  };
	
	  if (false) {
	    var sourceMapRegEx = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	    var oldStylis = stylis;
	
	    stylis = function stylis(selector, styles) {
	      var result = sourceMapRegEx.exec(styles);
	      currentSourceMap = result ? result[0] : '';
	      oldStylis(selector, styles);
	      currentSourceMap = '';
	    };
	  }
	
	  function insert(scope, styles) {
	    if (caches.inserted[name] === undefined) {
	      current = '';
	      stylis(scope, styles);
	      caches.inserted[name] = current;
	    }
	  }
	
	  var css = function css() {
	    var styles = createStyles.apply(this, arguments);
	    var selector = key + "-" + name;
	
	    if (caches.registered[selector] === undefined) {
	      caches.registered[selector] = styles;
	    }
	
	    insert("." + selector, styles);
	    return selector;
	  };
	
	  var keyframes = function keyframes() {
	    var styles = createStyles.apply(this, arguments);
	    var animation = "animation-" + name;
	    insert('', "@keyframes " + animation + "{" + styles + "}");
	    return animation;
	  };
	
	  var injectGlobal = function injectGlobal() {
	    var styles = createStyles.apply(this, arguments);
	    insert('', styles);
	  };
	
	  function getRegisteredStyles(registeredStyles, classNames) {
	    var rawClassName = '';
	    classNames.split(' ').forEach(function (className) {
	      if (caches.registered[className] !== undefined) {
	        registeredStyles.push(className);
	      } else {
	        rawClassName += className + " ";
	      }
	    });
	    return rawClassName;
	  }
	
	  function merge(className, sourceMap) {
	    var registeredStyles = [];
	    var rawClassName = getRegisteredStyles(registeredStyles, className);
	
	    if (registeredStyles.length < 2) {
	      return className;
	    }
	
	    return rawClassName + css(registeredStyles, sourceMap);
	  }
	
	  function cx() {
	    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      classNames[_key2] = arguments[_key2];
	    }
	
	    return merge(classnames(classNames));
	  }
	
	  function hydrateSingleId(id) {
	    caches.inserted[id] = true;
	  }
	
	  function hydrate(ids) {
	    ids.forEach(hydrateSingleId);
	  }
	
	  function flush() {
	    if (isBrowser) {
	      sheet.flush();
	      sheet.inject();
	    }
	
	    caches.inserted = {};
	    caches.registered = {};
	  }
	
	  function _ref3(node) {
	    // $FlowFixMe
	    sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe
	
	    node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
	  }
	
	  if (isBrowser) {
	    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(chunks, _ref3);
	  }
	
	  var emotion = {
	    flush: flush,
	    hydrate: hydrate,
	    cx: cx,
	    merge: merge,
	    getRegisteredStyles: getRegisteredStyles,
	    injectGlobal: injectGlobal,
	    keyframes: keyframes,
	    css: css,
	    sheet: sheet,
	    caches: caches
	  };
	  return emotion;
	}
	
	module.exports = createEmotion;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var emptyObject = __webpack_require__(36);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function hashString(str) {
	  return murmurhash2_32_gc(str, str.length).toString(36);
	}
	
	function murmurhash2_32_gc(str, seed) {
	  var l = str.length,
	      h = seed ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return h >>> 0;
	}
	
	var pa = function fa(ha) {
	  function V(b, c, d, k, l) {
	    for (var a = 0, f = 0, n = 0, e = 0, h, q, m, v = 0, A = 0, B = 0, x = 0, C = 0, p = 0, G = 0, r = 0, N = q = 0, L = 0, t = 0, D = d.length, F = D - 1, g = "", u = "", S = "", M = "", H; r < D;) {
	      m = d.charCodeAt(r);
	      r === F && 0 !== f + e + n + a && (0 !== f && (m = 47 === f ? 10 : 47), e = n = a = 0, D++, F++);
	
	      if (0 === f + e + n + a) {
	        if (r === F && (0 < q && (g = g.replace(P, "")), 0 < g.trim().length)) {
	          switch (m) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              g += d.charAt(r);
	          }
	
	          m = 59;
	        }
	
	        if (1 === N) switch (m) {
	          case 123:
	          case 125:
	          case 59:
	          case 34:
	          case 39:
	          case 40:
	          case 41:
	          case 44:
	            N = 0;
	
	          case 9:
	          case 13:
	          case 10:
	          case 32:
	            break;
	
	          default:
	            for (N = 0, t = r, h = m, r--, m = 59; t < D;) {
	              switch (d.charCodeAt(++t)) {
	                case 10:
	                case 13:
	                case 59:
	                  r++, m = h;
	
	                case 58:
	                case 123:
	                  t = D;
	              }
	            }
	
	        }
	
	        switch (m) {
	          case 123:
	            g = g.trim();
	            h = g.charCodeAt(0);
	            x = 1;
	
	            for (t = ++r; r < D;) {
	              m = d.charCodeAt(r);
	
	              switch (m) {
	                case 123:
	                  x++;
	                  break;
	
	                case 125:
	                  x--;
	              }
	
	              if (0 === x) break;
	              r++;
	            }
	
	            p = d.substring(t, r);
	            0 === h && (h = (g = g.replace(qa, "").trim()).charCodeAt(0));
	
	            switch (h) {
	              case 64:
	                0 < q && (g = g.replace(P, ""));
	                q = g.charCodeAt(1);
	
	                switch (q) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    h = c;
	                    break;
	
	                  default:
	                    h = W;
	                }
	
	                p = V(c, h, p, q, l + 1);
	                t = p.length;
	                0 < X && 0 === t && (t = g.length);
	                0 < E && (h = ia(W, g, L), H = O(3, p, h, c, I, y, t, q, l), g = h.join(""), void 0 !== H && 0 === (t = (p = H.trim()).length) && (q = 0, p = ""));
	                if (0 < t) switch (q) {
	                  case 115:
	                    g = g.replace(ra, sa);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    p = g + "{" + p + "}";
	                    break;
	
	                  case 107:
	                    g = g.replace(ta, "$1 $2" + (0 < Q ? T : ""));
	                    p = g + "{" + p + "}";
	                    p = 1 === w || 2 === w && U("@" + p, 3) ? "@-webkit-" + p + "@" + p : "@" + p;
	                    break;
	
	                  default:
	                    p = g + p, 112 === k && (p = (u += p, ""));
	                } else p = "";
	                break;
	
	              default:
	                p = V(c, ia(c, g, L), p, k, l + 1);
	            }
	
	            S += p;
	            p = L = q = G = N = C = 0;
	            g = "";
	            m = d.charCodeAt(++r);
	            break;
	
	          case 125:
	          case 59:
	            g = (0 < q ? g.replace(P, "") : g).trim();
	            if (1 < (t = g.length)) switch (0 === G && (h = g.charCodeAt(0), 45 === h || 96 < h && 123 > h) && (t = (g = g.replace(" ", ":")).length), 0 < E && void 0 !== (H = O(1, g, c, b, I, y, u.length, k, l)) && 0 === (t = (g = H.trim()).length) && (g = "\x00\x00"), h = g.charCodeAt(0), q = g.charCodeAt(1), h + q) {
	              case 0:
	                break;
	
	              case 169:
	              case 163:
	                M += g + d.charAt(r);
	                break;
	
	              default:
	                58 !== g.charCodeAt(t - 1) && (u += ja(g, h, q, g.charCodeAt(2)));
	            }
	            L = q = G = N = C = 0;
	            g = "";
	            m = d.charCodeAt(++r);
	        }
	      }
	
	      switch (m) {
	        case 13:
	        case 10:
	          if (0 === f + e + n + a + ka) switch (B) {
	            case 41:
	            case 39:
	            case 34:
	            case 64:
	            case 126:
	            case 62:
	            case 42:
	            case 43:
	            case 47:
	            case 45:
	            case 58:
	            case 44:
	            case 59:
	            case 123:
	            case 125:
	              break;
	
	            default:
	              0 < G && (N = 1);
	          }
	          47 === f ? f = 0 : 0 === z + C && (q = 1, g += "\x00");
	          0 < E * la && O(0, g, c, b, I, y, u.length, k, l);
	          y = 1;
	          I++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === f + e + n + a) {
	            y++;
	            break;
	          }
	
	        default:
	          y++;
	          h = d.charAt(r);
	
	          switch (m) {
	            case 9:
	            case 32:
	              if (0 === e + a + f) switch (v) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  h = "";
	                  break;
	
	                default:
	                  32 !== m && (h = " ");
	              }
	              break;
	
	            case 0:
	              h = "\\0";
	              break;
	
	            case 12:
	              h = "\\f";
	              break;
	
	            case 11:
	              h = "\\v";
	              break;
	
	            case 38:
	              0 === e + f + a && 0 < z && (q = L = 1, h = "\f" + h);
	              break;
	
	            case 108:
	              if (0 === e + f + a + J && 0 < G) switch (r - G) {
	                case 2:
	                  112 === v && 58 === d.charCodeAt(r - 3) && (J = v);
	
	                case 8:
	                  111 === A && (J = A);
	              }
	              break;
	
	            case 58:
	              0 === e + f + a && (G = r);
	              break;
	
	            case 44:
	              0 === f + n + e + a && (q = 1, h += "\r");
	              break;
	
	            case 34:
	              0 === f && (e = e === m ? 0 : 0 === e ? m : e);
	              break;
	
	            case 39:
	              0 === f && (e = e === m ? 0 : 0 === e ? m : e);
	              break;
	
	            case 91:
	              0 === e + f + n && a++;
	              break;
	
	            case 93:
	              0 === e + f + n && a--;
	              break;
	
	            case 41:
	              0 === e + f + a && n--;
	              break;
	
	            case 40:
	              if (0 === e + f + a) {
	                if (0 === C) switch (2 * v + 3 * A) {
	                  case 533:
	                    break;
	
	                  default:
	                    x = 0, C = 1;
	                }
	                n++;
	              }
	
	              break;
	
	            case 64:
	              0 === f + n + e + a + G + p && (p = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < e + a + n)) switch (f) {
	                case 0:
	                  switch (2 * m + 3 * d.charCodeAt(r + 1)) {
	                    case 235:
	                      f = 47;
	                      break;
	
	                    case 220:
	                      t = r, f = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === m && 42 === v && (33 === d.charCodeAt(t + 2) && (u += d.substring(t, r + 1)), h = "", f = 0);
	              }
	          }
	
	          if (0 === f) {
	            if (0 === z + e + a + p && 107 !== k && 59 !== m) switch (m) {
	              case 44:
	              case 126:
	              case 62:
	              case 43:
	              case 41:
	              case 40:
	                if (0 === C) {
	                  switch (v) {
	                    case 9:
	                    case 32:
	                    case 10:
	                    case 13:
	                      h += "\x00";
	                      break;
	
	                    default:
	                      h = "\x00" + h + (44 === m ? "" : "\x00");
	                  }
	
	                  q = 1;
	                } else switch (m) {
	                  case 40:
	                    C = ++x;
	                    break;
	
	                  case 41:
	                    0 === (C = --x) && (q = 1, h += "\x00");
	                }
	
	                break;
	
	              case 9:
	              case 32:
	                switch (v) {
	                  case 0:
	                  case 123:
	                  case 125:
	                  case 59:
	                  case 44:
	                  case 12:
	                  case 9:
	                  case 32:
	                  case 10:
	                  case 13:
	                    break;
	
	                  default:
	                    0 === C && (q = 1, h += "\x00");
	                }
	
	            }
	            g += h;
	            32 !== m && 9 !== m && (B = m);
	          }
	
	      }
	
	      A = v;
	      v = m;
	      r++;
	    }
	
	    t = u.length;
	    0 < X && 0 === t && 0 === S.length && 0 === c[0].length === !1 && (109 !== k || 1 === c.length && (0 < z ? K : R) === c[0]) && (t = c.join(",").length + 2);
	
	    if (0 < t) {
	      if (0 === z && 107 !== k) {
	        d = 0;
	        a = c.length;
	
	        for (f = Array(a); d < a; ++d) {
	          v = c[d].split(ua);
	          A = "";
	          B = 0;
	
	          for (D = v.length; B < D; ++B) {
	            if (!(0 === (x = (e = v[B]).length) && 1 < D)) {
	              r = A.charCodeAt(A.length - 1);
	              L = e.charCodeAt(0);
	              n = "";
	              if (0 !== B) switch (r) {
	                case 42:
	                case 126:
	                case 62:
	                case 43:
	                case 32:
	                case 40:
	                  break;
	
	                default:
	                  n = " ";
	              }
	
	              switch (L) {
	                case 38:
	                  e = n + K;
	
	                case 126:
	                case 62:
	                case 43:
	                case 32:
	                case 41:
	                case 40:
	                  break;
	
	                case 91:
	                  e = n + e + K;
	                  break;
	
	                case 58:
	                  switch (2 * e.charCodeAt(1) + 3 * e.charCodeAt(2)) {
	                    case 530:
	                      if (0 < Y) {
	                        e = n + e.substring(8, x - 1);
	                        break;
	                      }
	
	                    default:
	                      if (1 > B || 1 > v[B - 1].length) e = n + K + e;
	                  }
	
	                  break;
	
	                case 44:
	                  n = "";
	
	                default:
	                  e = 1 < x && 0 < e.indexOf(":") ? n + e.replace(va, "$1" + K + "$2") : n + e + K;
	              }
	
	              A += e;
	            }
	          }
	
	          f[d] = A.replace(P, "").trim();
	        }
	
	        c = f;
	      }
	
	      h = c;
	      if (0 < E && (H = O(2, u, h, b, I, y, t, k, l), void 0 !== H && 0 === (u = H).length)) return M + u + S;
	      u = h.join(",") + "{" + u + "}";
	
	      if (0 !== w * J) {
	        2 !== w || U(u, 2) || (J = 0);
	
	        switch (J) {
	          case 111:
	            u = u.replace(wa, ":-moz-$1") + u;
	            break;
	
	          case 112:
	            u = u.replace(Z, "::-webkit-input-$1") + u.replace(Z, "::-moz-$1") + u.replace(Z, ":-ms-input-$1") + u;
	        }
	
	        J = 0;
	      }
	    }
	
	    return M + u + S;
	  }
	
	  function ia(b, c, d) {
	    var k = c.trim().split(xa);
	    c = k;
	    var l = k.length,
	        a = b.length;
	
	    switch (a) {
	      case 0:
	      case 1:
	        var f = 0;
	
	        for (b = 0 === a ? "" : b[0] + " "; f < l; ++f) {
	          c[f] = ma(b, c[f], d, a).trim();
	        }
	
	        break;
	
	      default:
	        var n = f = 0;
	
	        for (c = []; f < l; ++f) {
	          for (var e = 0; e < a; ++e) {
	            c[n++] = ma(b[e] + " ", k[f], d, a).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function ma(b, c, d, k) {
	    var l = c.charCodeAt(0);
	    33 > l && (l = (c = c.trim()).charCodeAt(0));
	
	    switch (l) {
	      case 38:
	        switch (z + k) {
	          case 0:
	          case 1:
	            if (0 === b.trim().length) break;
	
	          default:
	            return c.replace(M, "$1" + b.trim());
	        }
	
	        break;
	
	      case 58:
	        switch (c.charCodeAt(1)) {
	          case 103:
	            if (0 < Y && 0 < z) return c.replace(ya, "$1").replace(M, "$1" + R);
	            break;
	
	          default:
	            return b.trim() + c;
	        }
	
	      default:
	        if (0 < d * z && 0 < c.indexOf("\f")) return c.replace(M, (58 === b.charCodeAt(0) ? "" : "$1") + b.trim());
	    }
	
	    return b + c;
	  }
	
	  function ja(b, c, d, k) {
	    var l = 0,
	        a = b + ";";
	    c = 2 * c + 3 * d + 4 * k;
	
	    if (944 === c) {
	      l = a.length;
	      b = a.indexOf(":", 9) + 1;
	      d = a.substring(0, b).trim();
	      k = a.substring(b, l - 1).trim();
	
	      switch (a.charCodeAt(9) * Q) {
	        case 0:
	          break;
	
	        case 45:
	          if (110 !== a.charCodeAt(10)) break;
	
	        default:
	          for (a = k.split((k = "", za)), b = c = 0, l = a.length; c < l; b = 0, ++c) {
	            for (var f = a[c], n = f.split(Aa); f = n[b];) {
	              var e = f.charCodeAt(0);
	              if (1 === Q && (64 < e && 90 > e || 96 < e && 123 > e || 95 === e || 45 === e && 45 !== f.charCodeAt(1))) switch (isNaN(parseFloat(f)) + (-1 !== f.indexOf("("))) {
	                case 1:
	                  switch (f) {
	                    case "infinite":
	                    case "alternate":
	                    case "backwards":
	                    case "running":
	                    case "normal":
	                    case "forwards":
	                    case "both":
	                    case "none":
	                    case "linear":
	                    case "ease":
	                    case "ease-in":
	                    case "ease-out":
	                    case "ease-in-out":
	                    case "paused":
	                    case "reverse":
	                    case "alternate-reverse":
	                    case "inherit":
	                    case "initial":
	                    case "unset":
	                    case "step-start":
	                    case "step-end":
	                      break;
	
	                    default:
	                      f += T;
	                  }
	
	              }
	              n[b++] = f;
	            }
	
	            k += (0 === c ? "" : ",") + n.join(" ");
	          }
	
	      }
	
	      k = d + k + ";";
	      return 1 === w || 2 === w && U(k, 1) ? "-webkit-" + k + k : k;
	    }
	
	    if (0 === w || 2 === w && !U(a, 1)) return a;
	
	    switch (c) {
	      case 1015:
	        return 45 === a.charCodeAt(9) ? "-webkit-" + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return "-webkit-" + a + a;
	
	      case 978:
	        return "-webkit-" + a + "-moz-" + a + a;
	
	      case 1019:
	      case 983:
	        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
	
	      case 883:
	        return 45 === a.charCodeAt(8) ? "-webkit-" + a + a : a;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
	
	          case 115:
	            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
	
	          case 98:
	            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
	        }
	        return "-webkit-" + a + "-ms-" + a + a;
	
	      case 964:
	        return "-webkit-" + a + "-ms-flex-" + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
	        return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
	
	      case 1005:
	        return Ba.test(a) ? a.replace(na, ":-webkit-") + a.replace(na, ":-moz-") + a : a;
	
	      case 1E3:
	        b = a.substring(13).trim();
	        l = b.indexOf("-") + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(l)) {
	          case 226:
	            b = a.replace(aa, "tb");
	            break;
	
	          case 232:
	            b = a.replace(aa, "tb-rl");
	            break;
	
	          case 220:
	            b = a.replace(aa, "lr");
	            break;
	
	          default:
	            return a;
	        }
	
	        return "-webkit-" + a + "-ms-" + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf("sticky", 9)) break;
	
	      case 975:
	        l = (a = b).length - 10;
	        b = (33 === a.charCodeAt(l) ? a.substring(0, l) : a).substring(b.indexOf(":", 7) + 1).trim();
	
	        switch (c = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, "-webkit-" + b) + ";" + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, "-webkit-" + (102 < c ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
	        }
	
	        return a + ";";
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
	
	          case 115:
	            return "-webkit-" + a + "-ms-flex-item-" + a.replace(Ca, "") + a;
	
	          default:
	            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "") + a;
	        }
	        break;
	
	      case 953:
	        if (0 < (l = a.indexOf("-content", 9)) && 109 === a.charCodeAt(l - 3) && 45 !== a.charCodeAt(l - 4)) return b = a.substring(l - 3), "width:-webkit-" + b + "width:-moz-" + b + "width:" + b;
	        break;
	
	      case 962:
	        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === d + k && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(Da, "$1-webkit-$2") + a;
	    }
	
	    return a;
	  }
	
	  function U(b, c) {
	    var d = b.indexOf(1 === c ? ":" : "{"),
	        k = b.substring(0, 3 !== c ? d : 10);
	    d = b.substring(d + 1, b.length - 1);
	    return ba(2 !== c ? k : k.replace(Ea, "$1"), d, c);
	  }
	
	  function sa(b, c) {
	    var d = ja(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return d !== c + ";" ? d.replace(Fa, " or ($1)").substring(4) : "(" + c + ")";
	  }
	
	  function O(b, c, d, k, l, a, f, n, e) {
	    for (var h = 0, q = c, m; h < E; ++h) {
	      switch (m = ca[h].call(F, b, q, d, k, l, a, f, n, e)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          q = m;
	      }
	    }
	
	    switch (q) {
	      case void 0:
	      case !1:
	      case !0:
	      case null:
	      case c:
	        break;
	
	      default:
	        return q;
	    }
	  }
	
	  function da(b) {
	    switch (b) {
	      case void 0:
	      case null:
	        E = ca.length = 0;
	        break;
	
	      default:
	        switch (b.constructor) {
	          case Array:
	            for (var c = 0, d = b.length; c < d; ++c) {
	              da(b[c]);
	            }
	
	            break;
	
	          case Function:
	            ca[E++] = b;
	            break;
	
	          case Boolean:
	            la = !!b | 0;
	        }
	
	    }
	
	    return da;
	  }
	
	  function ea(b) {
	    for (var c in b) {
	      var d = b[c];
	
	      switch (c) {
	        case "keyframe":
	          Q = d | 0;
	          break;
	
	        case "global":
	          Y = d | 0;
	          break;
	
	        case "cascade":
	          z = d | 0;
	          break;
	
	        case "compress":
	          oa = d | 0;
	          break;
	
	        case "semicolon":
	          ka = d | 0;
	          break;
	
	        case "preserve":
	          X = d | 0;
	          break;
	
	        case "prefix":
	          ba = null, d ? "function" !== typeof d ? w = 1 : (w = 2, ba = d) : w = 0;
	      }
	    }
	
	    return ea;
	  }
	
	  function F(b, c) {
	    if (void 0 !== this && this.constructor === F) return fa(b);
	    var d = b,
	        k = d.charCodeAt(0);
	    33 > k && (k = (d = d.trim()).charCodeAt(0));
	    0 < Q && (T = d.replace(Ga, 91 === k ? "" : "-"));
	    k = 1;
	    1 === z ? R = d : K = d;
	    d = [R];
	
	    if (0 < E) {
	      var l = O(-1, c, d, d, I, y, 0, 0, 0);
	      void 0 !== l && "string" === typeof l && (c = l);
	    }
	
	    var a = V(W, d, c, 0, 0);
	    0 < E && (l = O(-2, a, d, d, I, y, a.length, 0, 0), void 0 !== l && "string" !== typeof (a = l) && (k = 0));
	    K = R = T = "";
	    J = 0;
	    y = I = 1;
	    return 0 === oa * k ? a : a.replace(P, "").replace(Ha, "").replace(Ia, "$1").replace(Ja, "$1").replace(Ka, " ");
	  }
	
	  var qa = /^\0+/g,
	      P = /[\0\r\f]/g,
	      na = /: */g,
	      Ba = /zoo|gra/,
	      Da = /([,: ])(transform)/g,
	      za = /,+\s*(?![^(]*[)])/g,
	      Aa = / +\s*(?![^(]*[)])/g,
	      ua = / *[\0] */g,
	      xa = /,\r+?/g,
	      M = /([\t\r\n ])*\f?&/g,
	      ya = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,
	      Ga = /\W+/g,
	      ta = /@(k\w+)\s*(\S*)\s*/,
	      Z = /::(place)/g,
	      wa = /:(read-only)/g,
	      Ha = /\s+(?=[{\];=:>])/g,
	      Ia = /([[}=:>])\s+/g,
	      Ja = /(\{[^{]+?);(?=\})/g,
	      Ka = /\s{2,}/g,
	      va = /([^\(])(:+) */g,
	      aa = /[svh]\w+-[tblr]{2}/,
	      ra = /\(\s*(.*)\s*\)/g,
	      Fa = /([^]*?);/g,
	      Ca = /-self|flex-/g,
	      Ea = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      y = 1,
	      I = 1,
	      J = 0,
	      z = 1,
	      w = 1,
	      Y = 1,
	      oa = 0,
	      ka = 0,
	      X = 0,
	      W = [],
	      ca = [],
	      E = 0,
	      ba = null,
	      la = 0,
	      Q = 1,
	      T = "",
	      K = "",
	      R = "";
	  F.use = da;
	  F.set = ea;
	  void 0 !== ha && ea(ha);
	  return F;
	};
	
	var memoize = function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	};
	var STYLES_KEY = '__emotion_styles';
	var unitless = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.memoize = memoize;
	exports.STYLES_KEY = STYLES_KEY;
	exports.unitless = unitless;
	exports.hashString = hashString;
	exports.Stylis = pa;
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var createEmotion = _interopDefault(__webpack_require__(50));
	
	var context = typeof global !== 'undefined' ? global : {};
	
	var _createEmotion = createEmotion(context);
	var flush = _createEmotion.flush;
	var hydrate = _createEmotion.hydrate;
	var cx = _createEmotion.cx;
	var merge = _createEmotion.merge;
	var getRegisteredStyles = _createEmotion.getRegisteredStyles;
	var injectGlobal = _createEmotion.injectGlobal;
	var keyframes = _createEmotion.keyframes;
	var css = _createEmotion.css;
	var sheet = _createEmotion.sheet;
	var caches = _createEmotion.caches;
	
	exports.flush = flush;
	exports.hydrate = hydrate;
	exports.cx = cx;
	exports.merge = merge;
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.injectGlobal = injectGlobal;
	exports.keyframes = keyframes;
	exports.css = css;
	exports.sheet = sheet;
	exports.caches = caches;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(2));
	var emotion = __webpack_require__(23);
	var createEmotionStyled = _interopDefault(__webpack_require__(49));
	
	var index = createEmotionStyled(emotion, React);
	
	exports['default'] = index;
	Object.keys(emotion).forEach(function (key) { exports[key] = emotion[key]; });
	//# sourceMappingURL=index.cjs.js.map


/***/ }),

/***/ 294:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(445);
	var react_1 = tslib_1.__importDefault(__webpack_require__(2));
	var TransitionGroup_1 = tslib_1.__importDefault(__webpack_require__(426));
	var SlideDownContent = (function (_super) {
	    tslib_1.__extends(SlideDownContent, _super);
	    function SlideDownContent() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleRef = function (element) {
	            _this.element = element;
	            _this.callbacks = [];
	        };
	        _this.handleTransitionEnd = function (evt) {
	            if ((evt.target === _this.element) && (evt.propertyName === 'height')) {
	                var callback = _this.callbacks.shift();
	                callback && callback();
	                if (_this.callbacks.length === 0) {
	                    _this.element.classList.remove('transitioning');
	                    _this.element.style.transitionProperty = 'none';
	                    _this.element.style.height = _this.props.closed ? '0px' : 'auto';
	                    if (_this.props.closed)
	                        _this.element.classList.add('closed');
	                }
	            }
	        };
	        return _this;
	    }
	    SlideDownContent.prototype.componentDidMount = function () {
	        if (this.props.closed)
	            this.element.classList.add('closed');
	    };
	    SlideDownContent.prototype.componentWillAppear = function (callback) {
	        if (this.props.transitionOnAppear) {
	            this.callbacks.push(callback);
	            this.startTransition('0px');
	        }
	        else {
	            this.element.style.height = this.props.closed ? '0px' : 'auto';
	            callback();
	        }
	    };
	    SlideDownContent.prototype.componentWillEnter = function (callback) {
	        this.callbacks.push(callback);
	        var prevHeight = this.element.getBoundingClientRect().height + 'px';
	        this.startTransition(prevHeight);
	    };
	    SlideDownContent.prototype.componentWillLeave = function (callback) {
	        this.callbacks.push(callback);
	        this.element.classList.add('transitioning');
	        this.element.style.height = getComputedStyle(this.element).height;
	        this.element.offsetHeight;
	        this.element.style.transitionProperty = 'height';
	        this.element.style.height = '0px';
	    };
	    SlideDownContent.prototype.componentWillUpdate = function () {
	        if (this.callbacks.length === 0) {
	            this.element.style.height = this.element.getBoundingClientRect().height + 'px';
	        }
	    };
	    SlideDownContent.prototype.componentDidUpdate = function () {
	        var callback = this.callbacks.shift();
	        callback && callback();
	        if (this.callbacks.length === 0) {
	            var prevHeight = getComputedStyle(this.element).height;
	            this.startTransition(prevHeight);
	        }
	    };
	    SlideDownContent.prototype.startTransition = function (prevHeight) {
	        var endHeight = '0px';
	        if (!this.props.closed) {
	            this.element.classList.remove('closed');
	            this.element.style.height = 'auto';
	            endHeight = getComputedStyle(this.element).height;
	        }
	        if (parseFloat(endHeight).toFixed(2) !== parseFloat(prevHeight).toFixed(2)) {
	            this.element.classList.add('transitioning');
	            this.element.style.height = prevHeight;
	            this.element.offsetHeight;
	            this.element.style.transitionProperty = 'height';
	            this.element.style.height = endHeight;
	        }
	    };
	    SlideDownContent.prototype.render = function () {
	        var className = this.props.className ?
	            'react-slidedown ' + this.props.className : 'react-slidedown';
	        return (react_1.default.createElement("div", { className: className, ref: this.handleRef, onTransitionEnd: this.handleTransitionEnd }, this.props.children));
	    };
	    SlideDownContent.defaultProps = {
	        transitionOnAppear: true,
	        closed: false
	    };
	    return SlideDownContent;
	}(react_1.default.Component));
	function SlideDownWrapper(props) {
	    var childrenArray = react_1.default.Children.toArray(props.children);
	    return childrenArray[0] || null;
	}
	function SlideDown(props) {
	    var children = props.children, attrs = tslib_1.__rest(props, ["children"]);
	    var hasContent = (children && react_1.default.Children.count(children) !== 0);
	    return (react_1.default.createElement(TransitionGroup_1.default, { component: SlideDownWrapper }, hasContent && react_1.default.createElement(SlideDownContent, tslib_1.__assign({ key: 'content' }, attrs), children)));
	}
	exports.SlideDown = SlideDown;
	//# sourceMappingURL=slidedown.js.map

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(219);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(9);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(427);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, at, depth) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							insertRule(content)
						break
					// selector
					case 2:
						if (at === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (at) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + delimiter
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)(module)))

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	                t[p[i]] = s[p[i]];
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [0, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	        if (m) return m.call(o);
	        return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator];
	        return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(20);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _styles = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('blockquote', {
	  target: 'ek21whf0'
	})('margin:0 24px 24px;');
	
	var QuoteContent = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ek21whf1'
	})('padding:6px 0 6px 24px;border-left:10px solid ', _styles.gray1, ';font-size:20px;');
	
	var Source = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ek21whf2'
	})('margin-top:12px;padding-left:34px;font-size:16px;&::before{content:\'\u2013 \';}');
	
	var Blockquote = function (_Component) {
	  _inherits(Blockquote, _Component);
	
	  function Blockquote() {
	    _classCallCheck(this, Blockquote);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Blockquote.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        source = _props.source;
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(QuoteContent, { children: children }),
	      source && _react2.default.createElement(Source, { children: source })
	    );
	  };
	
	  _createClass(Blockquote, null, [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        header: _propTypes2.default.string
	      };
	    }
	  }]);
	
	  return Blockquote;
	}(_react.Component);
	
	exports.default = Blockquote;
	module.exports = exports['default'];

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(20);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactSlidedown = __webpack_require__(425);
	
	__webpack_require__(294);
	
	var _styles = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1lr23cp0'
	})('margin-top:24px;');
	
	var ProvisionHeader = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1lr23cp1'
	})('margin-bottom:10px;cursor:pointer;color:', _styles.linkColor, ';text-decoration:none;font-size:22px;font-weight:400;&::after{content:\'\u25BE\';position:relative;display:inline-block;margin:0 -1rem 0 0.5rem;transition:transform 300ms ease-in-out,top 300ms ease-in-out;transform-origin:center;', function (props) {
	  return props.isOpen ? 'transform: rotate(180deg);\n      top: 1px;' : '';
	}, '}');
	
	var slidedownStyles = /*#__PURE__*/(0, _reactEmotion.css)('transition-duration:300ms;');
	
	var Provision = function (_Component) {
	  _inherits(Provision, _Component);
	
	  function Provision(props) {
	    _classCallCheck(this, Provision);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleOpenToggle = function () {
	      _this.setState({ open: !_this.state.open });
	    };
	
	    _this.state = {
	      open: false
	    };
	    return _this;
	  }
	
	  Provision.prototype.render = function render() {
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(ProvisionHeader, { children: this.props.header, isOpen: this.state.open, onClick: this.handleOpenToggle }),
	      _react2.default.createElement(
	        _reactSlidedown.SlideDown,
	        { className: slidedownStyles },
	        this.state.open ? this.props.children : null
	      )
	    );
	  };
	
	  _createClass(Provision, null, [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        header: _propTypes2.default.string
	      };
	    }
	  }]);
	
	  return Provision;
	}(_react.Component);
	
	exports.default = Provision;
	module.exports = exports['default'];

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(20);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _blockquote = __webpack_require__(205);
	
	var _blockquote2 = _interopRequireDefault(_blockquote);
	
	var _provision = __webpack_require__(207);
	
	var _provision2 = _interopRequireDefault(_provision);
	
	var _styles = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Link from 'gatsby-link'
	// <Link to="/page-2/">Go to page 2</Link>
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e12h3s7g0'
	})('a{color:', _styles.linkColor, ';text-decoration:underline;font-weight:400;}strong{font-weight:600;}');
	
	var BodyColumn = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e12h3s7g1'
	})('box-sizing:border-box;max-width:920px;padding:0 20px;margin:0 auto;line-height:1.4;@media ', _styles.mqRuleAboveMobile, '{padding:0 60px;}');
	
	var HeadlineWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e12h3s7g2'
	})();
	
	var Subhead = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e12h3s7g3'
	})('margin:10px 0 28px;font-size:30px;font-weight:400;@media ', _styles.mqRuleAboveMobile, '{font-size:36px;}');
	
	var H1 = /*#__PURE__*/(0, _reactEmotion2.default)('h1', {
	  target: 'e12h3s7g4'
	})('font-size:52px;font-weight:600;@media ', _styles.mqRuleAboveMobile, '{font-size:72px;}');
	
	var H2 = /*#__PURE__*/(0, _reactEmotion2.default)('h2', {
	  target: 'e12h3s7g5'
	})('margin:80px 0 40px;text-align:center;font-size:40px;font-weight:600;');
	
	var H3 = /*#__PURE__*/(0, _reactEmotion2.default)('h3', {
	  target: 'e12h3s7g6'
	})('margin:0 0 16px;font-size:28px;font-weight:600;');
	
	var AllGroupsWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e12h3s7g7'
	})('display:flex;flex-direction:column;margin:10px 0 50px;@media ', _styles.mqRuleAboveMobile, '{flex-direction:row;}');
	
	var GroupWrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e12h3s7g8'
	})('flex:1;font-size:18px;& + &{margin-top:40px;@media ', _styles.mqRuleAboveMobile, '{margin-top:0;margin-left:60px;}}');
	
	var GroupHeader = /*#__PURE__*/(0, _reactEmotion2.default)(H3, {
	  target: 'e12h3s7g9'
	})('text-align:center;');
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      BodyColumn,
	      null,
	      _react2.default.createElement(
	        HeadlineWrapper,
	        null,
	        _react2.default.createElement(
	          H1,
	          null,
	          'Gun nuts and gun grabbers: stop banging your head against the wall. It\u2019s time to get results.'
	        )
	      ),
	      _react2.default.createElement(
	        Subhead,
	        null,
	        'The gun debate: 5% gun nuts, 5% gun grabbers, and 300 million people who just want to move forward.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'But we can\u2019t move forward. Really can\u2019t. Metaphysical can\u2019t. Unstoppable-force-versus-immovable-object can\u2019t. We\u2019re stuck and that\u2019s that.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The way we got here is simple:\xA0',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'each side is trying to destroy the other'
	        ),
	        '. You win wars by force. And culture wars are no different. Each side fires their volleys, back and forth.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The NRA allied itself to all kinds of unrelated hot-button issues. New York State passed a 2013 gun ban that achieved ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://hudsonvalleyone.com/2016/07/07/massive-noncompliance-with-safe-act/', target: '_blank' },
	          '4% compliance'
	        ),
	        ' and had effects like a father of three ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://wnyt.com/news/safe-act-fort-edward-washington-county-devon-pratt-steve-coffey-justin-derway/4626522/', target: '_blank' },
	          'facing 15 years in prison for a pistol grip'
	        ),
	        '. The NRA made ads that alienated millions of people and ranted absurdly about \u201Cthe clenched fist of truth\u201D. Massachusetts banned bump stocks and ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.necn.com/news/politics/Massachusetts-Sends-Bump-Stock-Deadline-Letter-to-Gun-Owners-1-Month-Late-470226803.html', target: '_blank' },
	          'sent a letter to every gun owner in the state'
	        ),
	        ' telling them to surrender their bump stocks by February 1, 2018. The maximum penalty for noncompliance is ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'life in prison'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Round it goes. The gun controllers feel like the gun rights crowd will never give an inch. The gun rights crowd feels personally threatened \u2014\xA0\u201CIf that father of three is facing 15 years for a pistol grip, I could be next.\u201D And both sides just dig in deeper.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Then we try rational arguments and fire off statistics, but the truth is ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'nobody cares'
	        ),
	        '. Each side has their arguments, each side has their stats, and none of it ever moves the needle. You convince a few people, they convince a few people. It\u2019s a wash.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'So then each side gives up on persuasion and tries to ram their laws through. But no matter which side you\u2019re on, the other side is strong enough to block your laws. Sure, you win some state-level battles here and there. But that only hardens the opposition, and they win their share of state-level battles too.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Both sides sell their donors the same pipe dream: \u201CWe\u2019re going to slowly change minds. Raise money, pass state-level laws, run PR campaigns, support good politicians. And one day, finally, we\u2019ll get 60 votes in the Senate to pass our dream federal gun law.\u201D If you understand only one thing about American gun politics, understand this: that will never happen.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'For decades we\u2019ve pretended not to know that. But these scorched earth tactics aren\u2019t working, and worse, they\u2019re tearing the country apart. Kids get murdered and we\u2019re too busy grabbing each other by the throat to even grieve, let alone to show the grace and love that ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.youtube.com/watch?v=-LGHtc_D328', target: '_blank' },
	          'the greatest among us'
	        ),
	        ' model. It\u2019s nauseating.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'It is high time for a fresh approach.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The other side isn\u2019t powerful enough to pass their laws, but they are powerful enough to stop you from passing yours. So if we accept the truth, that we will never agree, we have to ask a new question: how can we move forward even while everybody still disagrees? How can we write a law that ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'neither'
	        ),
	        ' side wants to block? The answer is going to test whether you\u2019re honestly willing to do what it takes to fix this stalemate.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'People in this debate often use the word \u201Ccompromise\u201D. But what they usually mean is, \u201CFine, let\u2019s compromise: we\u2019ll do none of what you want and only half of what I want.\u201D Neither side is dumb enough to fall for that. ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'An honest path forward'
	        ),
	        ' means something very different: ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'each side gives some things, and each side gets some things'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'So let\u2019s take the honest path, which is the only one that has any chance of happening. A path that advances gun rights ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'and'
	        ),
	        ' addresses people\u2019s concerns about guns in the wrong hands. I\'ve talked to dozens of people about this in person, and hundreds online. They ranged from people who would literally join a civil war against gun control, to people who want a flat-out ban on gun ownership, to every shade in between. Almost every one of them said they\u2019d support this proposal in a heartbeat. ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'The entire political spectrum is up for this.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Now it\u2019s time to see if the politicians and each side\u2019s big lobbying groups are up for it. It\u2019s fun to bluster and preach to your side. But when the time comes to actually do something, when there is a real path forward on the table, that\u2019s the true test. Your pressure on the politicians and lobbying groups will determine what they do next.'
	      ),
	      _react2.default.createElement(
	        H2,
	        { id: 'section0' },
	        'The Specifics of the Path'
	      ),
	      _react2.default.createElement(
	        AllGroupsWrapper,
	        null,
	        _react2.default.createElement(
	          GroupWrapper,
	          null,
	          _react2.default.createElement(
	            GroupHeader,
	            null,
	            'For the gun control side'
	          ),
	          _react2.default.createElement(
	            _provision2.default,
	            { header: '1. Swiss-style universal background checks' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Yup, the big enchilada. Gun rights people often worry that UBCs will turn into the government tracking (and later confiscating) everybody\u2019s guns, so this system staves off those fears while still making absolutely sure that every gun buyer is checked. It\u2019s modeled closely on Switzerland\u2019s system. Here\u2019s how it works:'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Any gun buyer can log into the NICS background check system and enter their personal information. The system gives them an ID number that expires in 1 week. (For reference ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.atf.gov/firearms/docs/4473-part-1-firearms-transaction-record-over-counter-atf-form-53009/download', target: '_blank' },
	                  'here is ATF Form 4473'
	                ),
	                ', the background check form.)'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The buyer can then buy firearms from any legal seller. They have to meet face-to-face (or ship the gun to a licensed dealer for the buyer to do the check with), and the buyer shows the ID number. The seller enters that number and the buyer\u2019s identification info into the NICS system, and the system returns just one word: \u201Capproved\u201D or \u201Cdenied\u201D. If the check is approved, they can proceed with the sale.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The system doesn\u2019t collect any information at all on the items being sold/transferred (type, make, model, quantity, etc.) \u2014 its only job is to run a comprehensive check on whether the buyer is legally allowed to purchase firearms. After one week, when the ID number expires, the system doesn\u2019t retain any records. (That information is already archived for 20 years on the Form 4473 for all gun shop sales, and that would stay the same.) The system collects no information about the seller, as it\u2019s designed to work perfectly without knowing the seller\u2019s identity.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Transfers between family members are exempt. Non-commercial firearm loans of up to 14 days are also exempt \u2014\xA0this is just to accommodate a situation where, say, two people are on a backcountry hunting trip and one needs to lend the other a gun during the trip. They need some way to do that without committing a felony.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _provision2.default,
	            { header: '2. Certain kinds of red flag laws' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'These laws allow a government to temporarily seize weapons from people who a court finds are plotting a violent act. These laws can be prone to abuse if written in a punitive, overly broad way (which has happened in a number of states), but well-written ones would likely have prevented some of the horrible mass shootings we\u2019ve seen. Congress doesn\u2019t have the power to create federal red flag laws, but it can pass a law that incentivizes states to create their own. The columnist David French wrote ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.nationalreview.com/2018/02/gun-control-republicans-consider-grvo/', target: '_blank' },
	                'an excellent outline'
	              ),
	              ' of what a good law looks like:'
	            ),
	            _react2.default.createElement(
	              _blockquote2.default,
	              null,
	              _react2.default.createElement(
	                'ol',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'It should limit those who have standing to seek the order to a narrowly defined class of people (close relatives, those living with the respondent);'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'It should require petitioners to come forward with clear, convincing, admissible evidence that the respondent is a significant danger to himself or others;'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'It should grant the respondent an opportunity to contest the claims against him;'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'In the event of an emergency, ',
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'ex parte'
	                  ),
	                  ' order (an order granted before the respondent can contest the claims), a full hearing should be scheduled quickly \u2014 preferably within 72 hours; and'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'The order should lapse after a defined period of time unless petitioners can come forward with clear and convincing evidence that it should remain in place.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Narrowly tailored, abuse-proof red flag laws cover a gap that the mental health system does not. The reality is that the focus on \u201Cmental health\u201D does two catastrophic things:'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'It shames and stigmatizes people with psychiatric diseases, which makes them less likely to seek the very treatment they need.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'It doesn\u2019t even address the problem. Very few people with mental illness will ever become violent, and most mass shooters ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.npr.org/2018/02/23/588374658/experts-say-theres-little-connection-between-mental-health-and-mass-shootings', target: '_blank' },
	                  'don\u2019t actually have any diagnosable mental illness'
	                ),
	                '. But most would-be killers do throw up exactly the kinds of red flags that a specifically designed law will catch.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _provision2.default,
	            { header: '3. Classify bump stocks as machine guns, banning them from sale' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'The purchase of new machine guns has been banned in the US since May 1986. The way the law defines \u201Cmachine gun\u201D is very specific, and it doesn\u2019t cover bump stocks. Therefore bump stocks can\u2019t legally be banned by executive action. (The ATF has been ordered by the Attorney General to ban them anyway, but that rule is unlikely to survive a challenge in court.)\xA0Congress will have to pass a law that classifies bump stocks as machine guns. Because the ATF ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://en.wikipedia.org/wiki/Bump_fire#Regulatory_status_in_the_United_States', target: '_blank' },
	                'specifically approved bump stocks for sale'
	              ),
	              ' in 2010, those people who bought one in good faith while it was legal should be allowed to register their bump stock with the ATF, subject to the same strict regulations as a machine gun, or to particpiate in a buyback program.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          GroupWrapper,
	          null,
	          _react2.default.createElement(
	            GroupHeader,
	            null,
	            'For the gun rights side'
	          ),
	          _react2.default.createElement(
	            _provision2.default,
	            { header: '1. Put silencers in the same legal category as handguns, not grenade launchers' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Because of an 84-year-old law (the National Firearms Act, or NFA), silencers (also called suppressors or mufflers) are currently in the same legal category as grenade launchers. To buy one, you pay a $200 tax to the ATF, and then you wait. Currently the average wait time is 7 months. Many people incorrectly believe that the long wait is for some kind of secret James Bond background check that takes 7 months to do. It\u2019s not; silencers are subject to ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.atf.gov/firearms/docs/4473-part-1-firearms-transaction-record-over-counter-atf-form-53009/download', target: '_blank' },
	                'the exact same background check'
	              ),
	              ' as all firearms are. The 7-month wait is literally just for the ATF to work through its paperwork backlog. Also, if you loan your silencer to a family member who\u2019s going on a hunting trip, that loan is a felony punishable by 10 years in federal prison. To stay out of jail, you\u2019d have to do the $200 tax + 7-month wait again just to loan the silencer to your dad. Then when he gives it back to you? $200 tax + 7-month wait again.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'So what do silencers do? Well, apart from an explosion or a rocket launch, a gunshot is quite simply the loudest sound in the human world. It is deafeningly, dangerously loud, around 165 debicels. Decibels are a logarithmic scale, so every 10 dB is 2x as loud. A jackhammer is 115 dB. A jet airplane taking off 25 yards away is 130 dB. The OSHA standard for sound that will ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'instantly damage your hearing'
	              ),
	              ' is 140 dB. Guns are another 4-6x louder than that OSHA cutoff.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'A silencer lowers a gunshot to about 130 dB. Contrary to what you see in movies, that\u2019s still 3x louder than a jackhammer. Extremely loud, but just quiet enough to not instantly damage your hearing. Gunshot detection systems like ShotSpotter still pick up silenced gunshots, because they listen for sound signature in addition to volume. Silencers are the only way to avoid hearing damage in situations where there\u2019s no chance to put on hearing protection \u2014\xA0that\'s why in countries like Norway and New Zealand, silencers are completely unregulated and it\u2019s considered unsafe to hunt without one.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This proposal is much more modest than that: simply change silencers from a Title II firearm to a Title I firearm. Instead of putting them in the same legal category as grenade launchers, put them in the same category as handguns \u2014\xA0available to adults who pass a NICS background check, denied to those who don\u2019t.'
	            )
	          ),
	          _react2.default.createElement(
	            _provision2.default,
	            { header: '2. Repeal Depression-era barrel length laws' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Because of the same 1934 law that affects silencers (the National Firearms Act, or NFA), rifles and shotguns in the US must have a minimum barrel length (16" and 18", respectively). So you can go to the store, pass a background check, and buy a rifle with a 16" barrel. But possessing that same exact rifle with a 15" barrel is a felony punishable by up to 10 years in federal prison.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'As an illustration of how arbitrary that is, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.youtube.com/watch?v=iNGz-kO4VYE', target: '_blank' },
	                'the well-meaning gun owner who recently went on Facebook and cut his gun in half'
	              ),
	              ' unknowingly broke this law \u2014\xA0his video shows him red-handed doing what the NFA describes as \u201Cillegally manufacturing a short-barreled rifle\u201D. For the harmless act in that video, he can be jailed for 10 years. It\u2019s only legal to cut your barrel below NFA length if you go through the $200 tax + 7-month wait process described in the silencer section above. Same process for all NFA items.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Contrary to popular belief, the barrel length law has nothing to do with dangerousness;\xA0the shorter the barrel on a rifle or shotgun, the ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'less'
	              ),
	              ' powerful and ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'less'
	              ),
	              ' accurate it is. The law is actually an interesting relic of how the NFA came to be. The first draft of the NFA included all handguns \u2014 in 1934 the $200 tax was equivalent to $3700 today, and it was designed to effectively ban all concealable weapons.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The bill\u2019s writers added the barrel length rules to stop people from buying a rifle, cutting down the barrel and the stock to make it almost as short as a handgun, and then saying, \u201CIt\u2019s a rifle, not a handgun.\u201D There was only one problem: there was no political support to include handguns in the NFA. The law wouldn\u2019t pass in that form. So the writers removed handguns from the NFA, but they never removed the barrel length rules that were only there to close the handgun loophole. ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'That'
	              ),
	              ' is why today a 16\u201D barrel is fine while a 15\u201D barrel is 10 years in federal prison.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This is a proposal to remove the barrel length rules from the NFA, moving those guns from Title II to Title I. Instead of putting them in the same category as grenade launchers, common sense dictates treating them like handguns (which are far more concealable) \u2014 available to adults who pass the NICS background check, denied to those who don\u2019t.'
	            )
	          ),
	          _react2.default.createElement(
	            _provision2.default,
	            { header: '3. Concealed carry permit reciprocity that\u2019s respectful of state law' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Carry laws vary dramatically from state to state. What\u2019s legal in one state might be a felony just over the border. That\u2019s how we get ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.washingtonpost.com/news/the-watch/wp/2014/07/22/shaneen-allen-race-and-gun-control/?utm_term=.7af69176bcad', target: '_blank' },
	                'cases like that of Shaneen Allen'
	              ),
	              ', a Pennsylvanian who was pulled over while driving in New Jersey. She was carrying a gun with her Pennsylvania permit, which New Jersey does not recognize. As a result, the New Jersey police charged her with a felony that carries a three-year mandatory minimum sentence. Only a pardon from the governor saved her, and that was after the single mother of two had already spent 48 days in jail. Pardons are very rare. Hundreds like Shaneen across the country never get one. And for every person that gets caught, there are likely dozens who are similarly at risk but just haven\u2019t been pulled over.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'State-level and local-level carry laws can be so complicated, and interact in such unpredictable ways, that there are lawyers who base their entire practice on advising people on these issues. There are valid state-rights concerns here about some expansive reciprocity law that nullifies all state and local carry laws. That\u2019s not what this is. This proposal is for a narrowly-tailored reciprocity law that simply aims to protect the Shaneen Allens of the world from being accidentally ensnared.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'To be covered by the law, a person would need to have a legal carry permit from their home state and be traveling temporarily in a different state. Nonresident permits would not qualify (e.g. a New York resident wouldn\u2019t be able to use a Utah nonresident permit to carry in New York). Being in a different state ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'not'
	              ),
	              ' temporarily (for example spending months at your vacation house) would also not qualify.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        AllGroupsWrapper,
	        null,
	        _react2.default.createElement(
	          GroupWrapper,
	          null,
	          _react2.default.createElement(
	            GroupHeader,
	            null,
	            'For everybody'
	          ),
	          _react2.default.createElement(
	            _provision2.default,
	            { header: '1. Mass shootings are a media contagion. The press can help stop it with the same anti-copycat guidelines they already use for suicides.' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Even amidst the fractal squabbling that poisons this whole debate, there is one idea that nearly everybody agrees on: ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'mass shootings are a media contagion'
	              ),
	              '. There\u2019s a large body of research on the subject, and it indicates that saturation media coverage of these horrors likely ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'causes'
	              ),
	              ' additional mass shootings.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Let\u2019s begin with the evidence on suicide reporting, which is subject to similar contagion effcts. (All bold emphasis below is mine.)'
	            ),
	            _react2.default.createElement(
	              _blockquote2.default,
	              {
	                source: _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://link.springer.com/article/10.1023/A:1009691903261', target: '_blank' },
	                    '\u201CPreventing suicide by influencing mass-media reporting. The Viennese experience 1980\u20131996\u201D, ',
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'Archives of Suicide Research'
	                    )
	                  )
	                )
	              },
	              'This paper reports a field experiment concerning mass-media and suicide. After the implementation of the subway system in Vienna in 1978, it became increasingly acceptable as means to commit suicide, with the suicide rates showing a sharp increase. This and the fact that the mass-media reported about these events in a very dramatic way, lead to the formation of a study-group of the Austrian Association for Suicide Prevention (\xD6VSKK), which developed media guidelines and launched a media campaign in mid-1987. ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Subsequently, the media reports changed markedly and the number of subway-suicides and -attempts dropped more than 80%'
	              ),
	              ' from the first to the second half of 1987, remaining at a rather low level since.'
	            ),
	            _react2.default.createElement(
	              _blockquote2.default,
	              {
	                source: _react2.default.createElement(
	                  'a',
	                  { href: 'http://abcnews.go.com/Health/story?id=117288&page=1', target: '_blank' },
	                  '\u201CGuidelines Given for Suicide Coverage\u201D, ABC News'
	                )
	              },
	              'Avoiding sensational coverage of suicides can prevent copycat suicides, a new federally endorsed guide for the media says. US Surgeon General David Satcher, along with academics and suicide experts today issued recommendations calling on the media not to give graphic details about suicides, and not to portray them as heroic or romantic or present them as inexplicable acts of healthy people.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Given those very compelling results, researchers have applied the same analytical techniques to the study of mass shootings.'
	            ),
	            _react2.default.createElement(
	              _blockquote2.default,
	              {
	                source: _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'http://www.apa.org/news/press/releases/2016/08/media-contagion.aspx', target: '_blank' },
	                    '\u201CMass Shootings and the Media Contagion Effect\u201D, research paper by psychology professor Jennifer Johnston and her student Andrew Joy'
	                  )
	                )
	              },
	              'If the mass media and social media enthusiasts make a pact to no longer share, reproduce, or re-tweet the names, faces, detailed histories, or long-winded statements of killers, we could see a dramatic reduction in mass shootings in the span of one to two years. Even conservatively, if the calculations of contagion modelers are correct, we should see at least a one third reduction in shootings if the contagion is removed. Given the profile of mass shooters, ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'we believe levels of mass murder could return to a pre-1970s rate, where it becomes a truly aberrant event'
	              ),
	              ' that although not eradicated, is no longer a common option that goes through the mind of every bullied, depressed, isolated, somewhat narcissistic man.'
	            ),
	            _react2.default.createElement(
	              _blockquote2.default,
	              {
	                source: _react2.default.createElement(
	                  'a',
	                  { href: 'http://www.psychiatrictimes.com/couch-crisis/after-las-vegas-danger-copy-cat-killers', target: '_blank' },
	                  'Ronald Pies, MD, editor emeritus of ',
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Psychiatric Times'
	                  )
	                )
	              },
	              _react2.default.createElement(
	                'p',
	                null,
	                'We need to be thinking ahead to the mass-shooters-in-waiting \u2014 the copycats who will use the Las Vegas murders as a template for their own horrific schemes. And we have good reason to believe that the more publicity the Las Vegas shooter garners, the greater the motivation of copycats to \u201Cdethrone\u201D him with the next mass shooting. (The reader will note that I do not use the Las Vegas shooter\u2019s name in this piece).'
	              )
	            ),
	            _react2.default.createElement(
	              _blockquote2.default,
	              {
	                source: _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.tandfonline.com/doi/full/10.1080/19392397.2017.1422984', target: '_blank' },
	                    '\u201CDo the media unintentionally make mass killers into celebrities? An assessment of free advertising and earned media value\u201D, a study by criminology professor Adam Lankford'
	                  )
	                )
	              },
	              'Findings indicate that the ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'mass killers received approximately $75 million in media coverage value'
	              ),
	              ', and that for extended periods following their attacks they received more coverage than professional athletes and only slightly less than television and film stars. In addition, during their attack months, some mass killers received more highly valued coverage than some of the most famous American celebrities, including Kim Kardashian, Brad Pitt, Tom Cruise, Johnny Depp, and Jennifer Aniston. Finally, most mass killers received more coverage from newspapers and broadcast/cable news than the public interest they generated through online searches and Twitter seems to warrant. Unfortunately, this media attention constitutes free advertising for mass killers that may increase the likelihood of copycats.'
	            ),
	            _react2.default.createElement(
	              _blockquote2.default,
	              {
	                source: _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.scientificamerican.com/article/mass-shootings-are-contagious/', target: '_blank' },
	                  '\u201CMass Shootings are Contagious\u201D, ',
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Scientific American'
	                  )
	                )
	              },
	              'Researchers at Arizona State University analyzed news reports of gun-related incidents from 1997 to 2013. They hypothesized that the rampages did not occur randomly over time but instead were clustered in patterns. The investigators applied a mathematical model and found that ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'shootings that resulted in at least four deaths launched a period of contagion'
	              ),
	              ', marked by a heightened likelihood of more bloodshed, ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'lasting an average of 13 days'
	              ),
	              '. Roughly 20 to 30 percent of all such violence took place in these windows.'
	            ),
	            _react2.default.createElement(
	              _blockquote2.default,
	              {
	                source: _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.youtube.com/watch?v=27aWHudLmgs', target: '_blank' },
	                    'Malcolm Gladwell lecture on school shootings as a contagion'
	                  ),
	                  ', based on a ',
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.newyorker.com/magazine/2015/10/19/thresholds-of-violence', target: '_blank' },
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'New Yorker'
	                    ),
	                    ' article he wrote'
	                  ),
	                  ' on the same subject'
	                )
	              },
	              _react2.default.createElement(
	                'p',
	                null,
	                'What [Columbine killers\u2019 names] are doing is laying out a script so precise that it makes it possible for kids with really really high thresholds to join in \u2026. They\u2019re making this particular \u201Criot\u201D more accessible.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                '[Name of a thwarted school shooter] is not a psychpath. He\u2019s a nerd. And 40 years ago he\u2019d be playing with his chemistry set in the basement and dreaming of being an astronaut. Because that was the available cultural narrative of that moment\u2026. Now he\u2019s dreaming of blowing up schools. He did not come up with that himself. He got it from the society of which he\u2019s a part, and we\u2019re responsible for that.'
	              )
	            ),
	            _react2.default.createElement(
	              _blockquote2.default,
	              {
	                source: _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.wsj.com/articles/what-mass-killers-want8212and-how-to-stop-them-1383957068', target: '_blank' },
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'The Wall Street Journal'
	                  )
	                )
	              },
	              _react2.default.createElement(
	                'p',
	                null,
	                'The perverse truth is that this senselessness is just the point of mass shootings: It is the means by which the perpetrator seeks to make us feel his hatred. Like terrorists, mass shooters can be seen, in a limited sense, as rational actors, who know that if they follow the right steps they will produce the desired effect in the public consciousness.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Part of this calculus of evil is competition. [Dr. Paul Mullen] spoke to a perpetrator who \u201Cgleefully admitted that he was \u2018going for the record\u2019\u201D.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Aside from the wealth of qualitative evidence for imitation in massacre killings, there are also some hard numbers. A 1999 study by Dr. Mullen and others in the ',
	                _react2.default.createElement(
	                  'em',
	                  null,
	                  'Archives of Suicide Research'
	                ),
	                ' suggested that a 10-year ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'outbreak of mass homicides had occurred in clusters rather than randomly'
	                ),
	                '. This effect was also found in a 2002 study by a group of German psychiatrists who examined 132 attempted rampage killings world-wide. There is a growing consensus among researchers that, whether or not the perpetrators are fully aware of it, they are following what has become a ready-made, free-floating template for young men to resolve their rage and express their sense of personal grandiosity.'
	              )
	            ),
	            _react2.default.createElement(
	              _blockquote2.default,
	              {
	                source: _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.theatlantic.com/national/archive/2012/12/the-media-needs-to-stop-inspiring-copycat-murders-heres-how/266439/', target: '_blank' },
	                    _react2.default.createElement(
	                      'em',
	                      null,
	                      'The Atlantic'
	                    )
	                  )
	                )
	              },
	              'My aim here is not to blame the media: such events have undeniable news value, and there is intense public interest in uncovering their details. But it\'s important to recognize that such incidents are not mono-causal, and sensational news coverage is, increasingly, part of the mix of events that contributes to these rampages.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Playing right into the memetic contagion, CNN has been heavily promoting a \u201Cfact sheet\u201D it made, which is ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.cnn.com/2013/09/16/us/20-deadliest-mass-shootings-in-u-s-history-fast-facts/index.html', target: '_blank' },
	                'literally a grotesque mass murder scoreboard.'
	              ),
	              ' Fox News, the New York Times, Breitbart, MSNBC, take your pick, nearly every big news organization feeds this contagion.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'All responsible press organizations should adopt the following set of guidelines by professor Adam Lankford, variations of which are echoed, according to ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.vox.com/the-big-idea/2018/2/22/17041382/school-shooting-media-coverage-perpetrator-parkland', target: '_blank' },
	                'a report from Vox'
	              ),
	              ', by the FBI, researchers at Texas State University, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://iloveuguys.org/', target: '_blank' },
	                'The I Love U Guys Foundation'
	              ),
	              ', and other groups across the country.'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Don\u2019t name the perpetrator.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Don\u2019t use photos or likenesses of the perpetrator.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Stop using the names, photos, or likenesses of past perpetrators.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Report everything else about these crimes in as much detail as desired.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _provision2.default,
	            { header: _react2.default.createElement(
	                'span',
	                null,
	                '2. \u2713 ',
	                _react2.default.createElement(
	                  'span',
	                  { style: { textDecoration: 'line-through' } },
	                  'Penalize agencies that fail to update the NICS background check system'
	                )
	              ) },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Update: this law was passed as part of the ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://en.wikipedia.org/wiki/Consolidated_Appropriations_Act,_2018#Weapons', target: '_blank' },
	                  '2018 omnibus bill'
	                ),
	                ' on March 23, 2018.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This is a simple one. A number of state and federal agencies are failing to consistently report prohibited possessors into the NICS background check system. That system won\u2019t work properly if its records aren\u2019t up-to-date, and Congress should fix these inconsistencies.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        H2,
	        { id: 'section1' },
	        'Your Action Plan'
	      ),
	      _react2.default.createElement(
	        H3,
	        null,
	        '1. Contact the lobbying groups that you donate to'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'These groups follow their donors\u2019 wishes. If they hear from you on a topic, they\u2019ll think about it. If they hear from ',
	        _react2.default.createElement(
	          'em',
	          null,
	          'enough'
	        ),
	        ' of you on a topic, they\u2019ll act. Contact every gun-related group you donate to, and tell them to support America\u2019s first honest path forward on guns. Commit to a specific dollar amount that you\u2019ll donate once they endorse the path forward.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Here are a couple of the biggest groups on each side:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://contact.nra.org/contact-us.aspx', target: '_blank' },
	            'National Rifle Association'
	          ),
	          ' - ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/NRA', target: '_blank' },
	            '@NRA'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://everytown.org/contact-us/', target: '_blank' },
	            'Everytown'
	          ),
	          ' - ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/everytown', target: '_blank' },
	            '@everytown'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.saf.org/contact-us-2/', target: '_blank' },
	            'Second Amendment Foundation'
	          ),
	          ' - ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/2afdn', target: '_blank' },
	            '@2afdn'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://giffords.org/act/contact/', target: '_blank' },
	            'Giffords'
	          ),
	          ' - ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/GiffordsCourage', target: '_blank' },
	            '@GiffordsCourage'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        H3,
	        null,
	        '2. Blow up Twitter about this'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Tweet tactically.'
	        ),
	        ' Anybody can tweet @realDonaldTrump and call it a day, but that accomplishes nothing. You need the person you\u2019re tweeting at to actually read what you wrote, and to share it with a lot of people.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Find your favorite medium-size Twitter accounts that talk about guns. The sweet spot is the 10,000-30,000 follower range. Enough to have a powerful audience, but cozy enough that they\u2019ll personally read your tweet. Engage with lots of those folks. If your tweets are worth reading, they\u2019ll quickly start replying and retweeting you. Then you\u2019re off to the races. ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'The ultimate goal: get this in front of people with big media platforms.'
	        ),
	        ' Top podcasters and YouTubers, big news shows, etc.'
	      ),
	      _react2.default.createElement(
	        H3,
	        null,
	        '3. Contact your House rep and your Senators'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Tell them you\u2019re done with the zero-sum scorched earth gun debate, and that you want a real path forward. ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Phone calls are much more effective than emails.'
	        ),
	        ' Use ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://callyourrep.co', target: '_blank' },
	          'callyourrep.co'
	        ),
	        ' to instantly find phone numbers for all of your members of Congress. ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://callyourrep.co/makeacallscript', target: '_blank' },
	          'Create a call script'
	        ),
	        ' and share it on Twitter so that other people can use the most effective script when they call their reps.'
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var fontFamilyStack = exports.fontFamilyStack = '"VerlagNormal", "Avenir Next", "Avenir", "Helvetica Neue", "Helvetica", sans-serif';
	
	var textColor = exports.textColor = '#363820';
	var linkColor = exports.linkColor = '#457c79';
	var backgroundColor = exports.backgroundColor = '#fbfbfb';
	var gray1 = exports.gray1 = '#f0f0f3';
	
	var mqRuleAboveMobile = exports.mqRuleAboveMobile = 'only screen and (min-width: 667px)';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-c515a92a8c3cc98a6a4a.js